<!-- <span *ngIf="icons != null; else notSys">
    <span *ngFor="let icon of icons">
      <fa-icon [icon]="icon"></fa-icon>
    </span>
  </span>
  <ng-template #notSys>
    {{params.value}}
  </ng-template> -->
  <span>
    <!-- <i class="fas fa-edit icons" *ngIf="params.showPrivilegeEdit" (click)="onEditClick(data.id)"></i> -->
    <!-- <i class="fas fa-trash icons" *ngIf="params.showZenDelete" (click)="onDeleteClick(data.id)"></i> -->
  </span>

  <span>
    <!-- <i class="fas fa-edit icons" *ngIf="params.showZenEdit" (click)="onEdit(data.value)"></i> -->
    <!-- <i class="fas fa-trash icons" *ngIf="params.showZenDelete" (click)="onDelete(data.name)"></i> -->
  </span>

  <!-- <span>
    <i class="fas fa-edit icons" (click)="onEditClick(data.id)"></i>
    <i class="fas fa-trash icons" (click)="onDeleteClick(data.id)"></i>
  </span> -->

  <span>
    <i *ngIf="params.componentIdentifier === 'zendesk'" class="fas fa-edit icons" (click)="params.onEditClick(data.id)"></i>
    <i *ngIf="params.componentIdentifier !== 'zendesk'" class="fas fa-edit icons" (click)="params.onEditClick(data.id)"></i>
  
    <!-- <i *ngIf="params.componentIdentifier === 'zendesk'" class="fas fa-trash icons" (click)="params.onDelete(params.value)"></i> -->
    <i *ngIf="params.componentIdentifier !== 'zendesk'" class="fas fa-trash icons" (click)="params.onDeleteClick(data.id)"></i>
  </span>
  